'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.p.withConfig({
  componentId: 's1jw1vsx-0'
})(['margin:0;font-size:0.8em;padding-bottom:calc(', ');line-height:1.2em;'], function (p) {
  return p.theme.spacingUnit;
});